import api from "src/api/axios";

const createTrip = async (data) => {
  return api.post(`/trips/create-trip`, data).then((result) => {
    return result.data;
  });
};

const assignOrdersToTrip = async (data) => {
  return api.post("/trips/assign-to-trip", data);
};

const getBulkTripInfo = async (id) => {
  return api
    .get(`/booking-orders/assign-multiple-trip/${id}`)
    .then((result) => {
      return result.data;
    });
};

const createBulkTrip = async (input, id) => {
  return api
    .post(`/booking-orders/assign-multiple-trip/${id}`, input)
    .then((result) => {
      return result.data;
    });
};

const createMultipleOrders = async (input) => {
  return api.post(`/booking-orders/multiple-orders`, input).then((result) => {
    return result.data;
  });
};

const updateTrip = async (input, id) => {
  return api.patch(`/trips/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateActiveStatus = async (input, id) => {
  return api.patch(`/trips/active-inactive/${id}`, input).then((result) => {
    return result.data;
  });
};

const getSingleTrip = async (id) => {
  return api.get(`/trips/${id}`).then((result) => {
    return result.data;
  });
};

//Test Trip

const getTripList = async (urlParams) => {
  const params = new URLSearchParams();
  for (const key in urlParams) {
    if (urlParams.hasOwnProperty(key)) {
      const value = urlParams[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        if (key === "sort" && Array.isArray(value)) {
          // If it's the sort parameter and it's an array, join it
          params.append(key, value.join(","));
        } else {
          params.append(key, value);
        }
      }
    }
  }

  return api.get(`/trips/trip-list/all?${params}`).then((result) => {
    return result.data;
  });
};

const getTripById = async (id, urlParams = null) => {
  const params = new URLSearchParams();

  if (urlParams) {
    for (const key in urlParams) {
      if (urlParams.hasOwnProperty(key)) {
        const value = urlParams[key];
        // Check if the value is not null or undefined or not empty string
        if (value) {
          if (key === "sort" && Array.isArray(value)) {
            // If it's the sort parameter and it's an array, join it
            params.append(key, value.join(","));
          } else {
            params.append(key, value);
          }
        }
      }
    }
  }
  return api
    .get(`/trips/trip-orders/${id}?${params}`)
    .then((result) => result.data);
};

const removeBookingOrderFromTrip = async (id, body) => {
  return api
    .patch(`/trips/accept-reject/${id}`, body)
    .then((result) => result.data);
};

const exportTrips = (data) => {
  const params = new URLSearchParams();
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        if (key === "sort" && Array.isArray(value)) {
          // If it's the sort parameter and it's an array, join it
          params.append(key, value.join(","));
        } else {
          params.append(key, value);
        }
      }
    }
  }
  return api.get(`/trips/export-trips?${params}`);
};

const cancelMultipleTrips = (data) =>
  api.patch("/trips/cancel-multiple-trips", data);

export {
  createTrip,
  getTripList,
  getSingleTrip,
  updateTrip,
  updateActiveStatus,
  createBulkTrip,
  getBulkTripInfo,
  createMultipleOrders,
  getTripById,
  removeBookingOrderFromTrip,
  assignOrdersToTrip,
  exportTrips,
  cancelMultipleTrips,
};
